import React, { useEffect } from 'react';
import { Typography } from '@navi/web-ui/lib/primitives';
import { CallType, CallTypeResponse, NumberOfCalls, timeSlots } from '../constants';
import renderColorIndication from '../RenderColorIndication';
import renderCallRow from './RenderCallRow';
import { useState } from 'react';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { fetchCallData } from '../activityTrackerAction';

interface TodaysCallCardProps {
  agentRefId?: string;
}

const TodaysCallCard: React.FC<TodaysCallCardProps> = ({ agentRefId }) => {
  const dispatch = useDispatch();

  const agentReferenceId = useSelector((state: RootState) => state.common.userData.referenceId);

  const callStats =
    useSelector((state: RootState) => state.leaderboard).dailyCallActivityData?.callStats || {};

  const [isLoading, setIsLoading] = useState(true);

  const agentRefIdForActivityCard = agentRefId || agentReferenceId;
  useEffect(() => {
    if (agentRefIdForActivityCard) {
      dispatch(fetchCallData(setIsLoading, agentRefIdForActivityCard));
    }
  }, [agentRefIdForActivityCard]);

  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-start mb-2">
        <Typography variant="h6">Calls</Typography>
        <div className="flex space-x-4 mr-[-25px]">
          {renderColorIndication(NumberOfCalls.FiftyPlus, 'var(--blue-dark-1)')}
          {renderColorIndication(NumberOfCalls.ThirtyPlus, 'var(--blue-light-2)')}
          {renderColorIndication(NumberOfCalls.OneToThirty, 'var(--blue-light-3)')}
        </div>
      </div>
      <SuspenseLoader
        loading={isLoading}
        fallBack={
          <>
            <LineLoader numberOfLines={5} />
          </>
        }
      >
        <div className="bg-[var(--bg-blue-1)] px-4 py-[13px] rounded-lg  w-full">
          <div className="flex flex-row items-center">
            <div className="w-24 text-left">
              <Typography variant="p5" color="var(--grayscale-2)">
                Call time
              </Typography>
            </div>
            <div className="flex-1 w-full flex justify-between">
              {timeSlots.map((slot, index) => (
                <div key={`time-${index}`} className="text-xs text-gray-500">
                  {slot.time}
                </div>
              ))}
            </div>
          </div>
          {callStats[CallTypeResponse.SLASH] &&
            renderCallRow(CallType.Slash, callStats[CallTypeResponse.SLASH])}
          {callStats[CallTypeResponse.AMEYO] &&
            renderCallRow(CallType.Ameyo, callStats[CallTypeResponse.AMEYO])}
          {callStats[CallTypeResponse.SELF] &&
            renderCallRow(CallType.SelfCall, callStats[CallTypeResponse.SELF])}
        </div>
      </SuspenseLoader>
    </div>
  );
};

export default TodaysCallCard;
